import { render } from "./PopUp.vue?vue&type=template&id=2b7210f2&scoped=true"
import script from "./PopUp.vue?vue&type=script&lang=js"
export * from "./PopUp.vue?vue&type=script&lang=js"

import "./PopUp.vue?vue&type=style&index=0&id=2b7210f2&lang=scss&scoped=true"

import exportComponent from "D:\\Work\\git\\CatalogOnVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b7210f2"]])

export default __exports__